import { Canvas } from "@react-three/fiber"
import { Suspense } from "react"
import { Loader, OrbitControls } from "@react-three/drei"
import React, { useState } from "react"
import ReactPlayer from 'react-player'
import Zoom from 'react-medium-image-zoom'
import { useTranslation, Trans } from 'react-i18next';

import "react-medium-image-zoom/dist/styles.css";

import Collapse from "../components/collapse"
import KanedaMoto from "../components/motoKaneda"
import JokerMoto from "../components/motoJoker"
import Lights from "../components/lights"
import Slideshow from "../components/slideshow"

import refCapelli from "../assets/img/prod/capelli/capelli_reference.png"
import curvePanelCapelli from "../assets/img/prod/capelli/capelli_curve_panel.png"
import proxiesNodes from "../assets/img/prod/proxies/proxies_nodes.png"
import proxiesVw01 from "../assets/img/prod/proxies/proxies_vw_01.png"
import proxiesVw02 from "../assets/img/prod/proxies/proxies_vw_02.png"
import proxiesVw03 from "../assets/img/prod/proxies/proxies_vw_03.png"
import allDisplay from "../assets/video/all_display.mp4"
import jokerLight from "../assets/img/prod/original_joker_wronglight.png"
import streetMaterial from "../assets/img/prod/materiali/material_strada.png"
import wheelMaterial from "../assets/img/prod/materiali/material_ruota.png"
import motoMaterial from "../assets/img/prod/materiali/material_scocca_kaneda.png"
import vetroMaterial from "../assets/img/prod/materiali/material_vetro.png"
import motoJokerMaterial from "../assets/img/prod/materiali/jokermoto.png"
import kanedaFront from "../assets/img/prod/characters/kaneda/bg2.png"
import kanedaBack from "../assets/img/prod/characters/kaneda/bg4.png"
import kanedaSide from "../assets/img/prod/characters/kaneda/bg6.png"
import jokerFront from "../assets/img/prod/characters/joker/bg1.png"
import jokerBack from "../assets/img/prod/characters/joker/bg3.png"
import jokerSide from "../assets/img/prod/characters/joker/bg5.png"
import kanedaGiacca from "../assets/img/prod/viewport/kaneda_giacca.png"
import normali from "../assets/img/prod/viewport/normali.png"
import head01 from "../assets/img/prod/head/head01.png"
import head02 from "../assets/img/prod/head/head02.png"
import head03 from "../assets/img/prod/head/head03.png"
import head04 from "../assets/img/prod/head/head04.png"
import head05 from "../assets/img/prod/head/head05.png"
import head06 from "../assets/img/prod/head/head06.png"
import inverseK from "../assets/img/prod/viewport/manubrio_ik.png"
import schema_lacci from "../assets/img/prod/altro/schema_lacci.jpg"
import lacci from "../assets/img/prod/altro/lacci.png"
import rigJoker from "../assets/img/prod/altro/rig_joker.png"
import caduta from "../assets/video/joker_caduto.mp4"
import scintilla01 from "../assets/img/prod/vfx/scintilla01.png"
import scintilla02 from "../assets/img/prod/vfx/scintilla02.png"
import scintilla03 from "../assets/img/prod/vfx/scintilla03.png"
import scintilla04 from "../assets/img/prod/vfx/scintilla04.png"
import sassolini01 from "../assets/img/prod/vfx/sassolini01.png"
import sassolini02 from "../assets/img/prod/vfx/sassolini02.png"
import fumo01 from "../assets/img/prod/vfx/fumo01.png"
import timeline from "../assets/img/prod/timeline/timeline_s14.png"
import grease03 from "../assets/img/prod/grease/gp1.png"
import grease04 from "../assets/img/prod/grease/gp2.png"
import grease05 from "../assets/img/prod/grease/gp3.png"
import cloth01 from "../assets/img/prod/cloth/c1.png"
import cloth02 from "../assets/img/prod/cloth/c2.png"


const head = [head01, head02, head03, head04, head05, head06]
const proxies = [proxiesVw01, proxiesVw02, proxiesVw03]
const kanedaPose = [kanedaFront, kanedaBack, kanedaSide]
const jokerPose = [jokerSide, jokerBack, jokerFront]
const scintilla = [scintilla01, scintilla02]
const particelle = [scintilla03, scintilla04]
const sassolini = [sassolini01, sassolini02]
const grease = [grease03, grease04, grease05]
const cloth = [cloth01, cloth02]


export default function Production() {

  const { t, i18n } = useTranslation();

  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [motoShown, setMotoShown] = useState(0);
  const onLoadedData = () => {
    setIsVideoLoaded(true);
  };
  const toggleMoto = () => {
    setMotoShown(motoShown === 0 ? 1 : 0)
  }

  return (

    <div className="row main-row">
      <div className="column column-75 container column-offset-10">
        <div className="row section">
          <div className="column column-25">
            <h1><span className="bold">PRODUCTION</span></h1>
          </div>
        </div>
        <div className="row section capsule">
          <div className="column column-25"> </div>
          <div className="column column-offset-10">
            <p>
              <Trans i18nKey="description.prod1">
              </Trans>
            </p>
            <h3>   <Trans i18nKey="description.prodTitle">
            </Trans></h3>
            <p>
              <Trans i18nKey="description.prod2">
              </Trans>
            </p>
            <p>
              <Trans i18nKey="description.prod3">
              </Trans>
            </p>
            <blockquote>
              <p><em><span className="bold">Sources:</span>
                <br /><a href="https://community.gamedev.tv/t/eevees-shadows/213112/4" target="blank">Eevee's shadows - community post</a>
                <br /><a href="https://www.youtube.com/watch?v=K6Oom8gFch4" target="blank">Fix Eevee Shadow quality Blender - video</a>
              </em></p>
            </blockquote>
          </div>
        </div>


        <Collapse
          name={<Trans i18nKey="description.modellingTitle">
          </Trans>}
        >
          <div className="row section capsule">
            <div className="column column-25"></div>
            <div className="column column-offset-10">
              <p>
                <Trans i18nKey="description.modelling1">
                </Trans>
              </p>
            </div>
          </div>

          <div className="row section">
            <div className="column column-25">
            </div>

            <div className="column column-offset-10">
              <h3><Trans i18nKey="description.modellingMoto" /></h3>
              <p>
                <Trans
                  i18nKey="description.modelling2"
                  components={{ italics: <span className="italics" /> }}
                />
              </p>
            </div>
          </div>

          <div className="row section">
            <div className="column column-25">
            </div>

            <div className="column column-offset-10">
              <Canvas className="canvas">
                <Lights />
                <Suspense fallback={<Loader />}>
                  {motoShown === 0 ? <KanedaMoto /> : <JokerMoto />}
                </Suspense>
                <OrbitControls
                  autoRotate={true}
                  maxDistance={5}
                  minDistance={1}
                />
              </Canvas>

            </div>

          </div>
          <div className="row section">
            <div className="column column-25"></div>
            <div className="column column-offset-10">
              <button onClick={toggleMoto}>Switch Moto</button>
            </div>
          </div>

          <div className="row section">
            <div className="column column-25">
            </div>

            <div className="column column-offset-10">
              <h3><Trans i18nKey="description.modellingCharacters" /></h3>
              <p>
                <Trans
                  i18nKey="description.modelling3"
                  components={{ bold: <span className="bold" /> }}
                />
              </p>

              <p>
                <Trans
                  i18nKey="description.modelling4"
                  components={{
                    bold: <span className="bold" />,
                    italics: <span className="italics" />
                  }}
                />
              </p>
              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://www.youtube.com/watch?v=uptuXWNWpk0" target="blank">How to Make Anime FACE in Blender Explained! + Custom Shadows</a>
                </em></p>
              </blockquote>
              <Slideshow img={head} />
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did1" />
                </p>
              </div>
              <p>
                <Trans
                  i18nKey="description.modelling5"
                  components={{ bold: <span className="bold" /> }}
                />
              </p>
              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://www.youtube.com/watch?v=ethg2nYSjqg" target="blank">How to create FAST Stylized Hair/Fur in Blender 4.0 post</a>
                </em></p>
              </blockquote>
              <div className="row images">
                <Zoom>
                  <img src={refCapelli} alt="hair reference"></img>
                </Zoom>
                <Zoom>
                  <img src={curvePanelCapelli} alt="pannello curve capelli" style={{ paddingLeft: "1rem" }}></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did2" />
                </p>
              </div>

              <p>
                <Trans
                  i18nKey="description.modelling6"
                  components={{
                    bold: <span className="bold" />,
                    italics: <span className="italics" />
                  }} />
              </p>
              <div className="row images">
                <Zoom>
                  <img src={kanedaGiacca} alt="Giacca di Kaneda"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did3" />
                </p>
              </div>


              <Trans
                i18nKey="description.modelling7"
                components={{ bold: <span className="bold" /> }}
              />
              <blockquote>
                <p><em><span className="bold">Source:</span>
                  <br /><a href="https://github.com/bnpr/Abnormal" target="blank">Abnormal add-on</a>
                </em></p>
              </blockquote>
              <div className="row images">
                <Zoom>
                  <img src={normali} alt="normali"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did4" />
                </p>
              </div>
            </div>
          </div>

          <div className="row section">
            <div className="column column-25"> </div>

            <div className="column column-offset-10">
              <h3> <Trans i18nKey="description.modellingEnvironment" /></h3>
              <p>
                <Trans i18nKey="description.modelling8" />
              </p>
              <p>
                <Trans
                  i18nKey="description.modelling9"
                  components={{
                    italics: <span className="italics" />
                  }} />
              </p>

              <div className="row images">
                <Zoom>
                  <img src={proxiesNodes} alt="Node proxies"></img>
                </Zoom>
              </div>

              <Slideshow img={proxies} />

              <div className="caption">
                <p>
                  <Trans
                    i18nKey="description.did5"
                    components={{ italics: <span className="italics" /> }} />
                </p>
              </div>
            </div>
          </div>

          <div className="row section">
            <div className="column column-25"></div>
            <div className="column column-offset-10">
              <h3>Grease pencil</h3>
              <p>
                <Trans
                  i18nKey="description.modelling10"
                  components={{
                    italics: <span className="italics" />
                  }} />
              </p>
              <blockquote>
                <p><em><span className="bold">Sources:</span>
                  <br /><a href="https://www.youtube.com/watch?v=BzTN2yTgTj0" target="blank">My Blender 2D/3D Process with Grease Pencil</a>
                  <br /><a href="https://www.youtube.com/watch?v=xPS3AYe4WJs" target="blank">Experimenting with Blender's Grease Pencil Interpolation</a>
                </em></p>
              </blockquote>
              <Slideshow img={grease} />
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did6" />
                </p>
              </div>
            </div>
          </div>
        </Collapse>


        <Collapse
          name={<Trans i18nKey="description.materialTitle" />}
        >
          <div className="row section capsule">
            <div className="column column-25">  </div>

            <div className="column column-offset-10">
              <p>
                <Trans i18nKey="description.material1" />
              </p>
              <div className="row images">
                <Zoom>
                  <img src={motoMaterial} alt="materiale moto"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did7" />
                </p>
              </div>

              <p>
                <Trans
                  i18nKey="description.material2"
                  components={{
                    italics: <span className="italics" />,
                    bold: <span className="bold" />,
                    list: <ul></ul>,
                    elementList: <li></li>
                  }} />
              </p>
              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://blender.stackexchange.com/questions/81851/does-transparency-work-in-eevee " target="blank">Transparency in Eevee</a>
                  <br /><a href="https://www.youtube.com/watch?v=g3PR4uzbXjs" target="blank">How to make a parallax shader</a>
                </em></p>
              </blockquote>
              <div className="row images">
                <Zoom>
                  <img src={vetroMaterial} alt="materiale moto"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did8" />
                </p>
              </div>
              <p>
                <Trans
                  i18nKey="description.material3"
                  components={{ bold: <span className="bold" />, }} />
              </p>
              <ReactPlayer
                url={allDisplay}
                playing={true}
                controls={false}
                muted={true}
                playsinline={true}
                loop={true}
                onReady={onLoadedData}
                width={"100%"}
                height={"auto"}
              />
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did9" />
                </p>
              </div>

              <p>
                <Trans
                  i18nKey="description.material4"
                  components={{ bold: <span className="bold" />, }} />
              </p>
              <div className="row images">
                <Zoom>
                  <img src={wheelMaterial} alt="materiale strada"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did10" />
                </p>
              </div>

              <p>
                <Trans
                  i18nKey="description.material5"
                  components={{ bold: <span className="bold" />, }} />
              </p>
              <div className="row images">
                <Zoom>
                  <img src={motoJokerMaterial} alt="moto Joker"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did11" />
                </p>
              </div>
              <p>
                <Trans
                  i18nKey="description.material6"
                  components={{ bold: <span className="bold" />, }} />
              </p>

              <div className="row images">
                <Zoom>
                  <img src={streetMaterial} alt="materiale strada"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did12" />
                </p>
              </div>


            </div>
          </div>

          <div className="row">
            <div className="column column-25"></div>
            <div className="column caption column-offset-10">
              <Slideshow img={kanedaPose} />
              <p>
                <Trans i18nKey="description.did13" />
              </p>
            </div>
          </div>
          <div className="row">
            <div className="column column-25"></div>
            <div className="column caption column-offset-10">
              <Slideshow img={jokerPose} />
              <p>
                <Trans i18nKey="description.did14" />
              </p>
            </div>
          </div>
        </Collapse>


        <Collapse
          name={"Mise-en-scéne"}
        >
          <div className="row section capsule">
            <div className="column column-25">
            </div>

            <div className="column column-offset-10">
              <p>
                <Trans i18nKey="description.miseEnScene1" />
              </p>
              <div className="row images">
                <img src={jokerLight} alt="jokerLight"></img>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did15" />
                </p>
              </div>
              <p>
                <Trans i18nKey="description.miseEnScene2" />
              </p>
            </div>
          </div>
        </Collapse>


        <Collapse
          name={"VFX"}
        >
          <div className="row section capsule">
            <div className="column column-25">
            </div>

            <div className="column column-offset-10">
              <p>
                <Trans
                  i18nKey="description.vfx1"
                  components={{ bold: <span className="bold" />, }} />
              </p>
              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://www.youtube.com/watch?v=7_loDcu7N8o" target="blank">How to make lightning strike and ground collapse tutorial</a>
                </em></p>
              </blockquote>
              <Slideshow img={scintilla} />
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did16" />
                </p>
              </div>
              <p>
                <Trans
                  i18nKey="description.vfx2"
                  components={{ bold: <span className="bold" />, }} />
              </p>
              <Slideshow img={particelle} />
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did17" />
                </p>
              </div>
              <p>
                <Trans
                  i18nKey="description.vfx3"
                  components={{ bold: <span className="bold" />, }} />
              </p>
              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://www.youtube.com/watch?v=j0r-pG8uulY " target="blank">Blender tire smoke effect tutorial</a>
                  <br /><a href="https://www.youtube.com/watch?v=4QMuXQH_5ZA" target="blank">Volume to Mesh Modifier w/ Mantaflow (2.91)</a>
                </em></p>
              </blockquote>
              <p>
                <div className="row images">
                  <Zoom>
                    <img src={fumo01} alt="fumo"></img>
                  </Zoom>
                </div>
                <div className="caption">
                  <p>
                    <Trans i18nKey="description.did18" />
                  </p>
                </div>
                <Trans
                  i18nKey="description.vfx4"
                  components={{ bold: <span className="bold" />, }} />
              </p>
              <Slideshow img={sassolini} />
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did19" />
                </p>
              </div>
            </div>
          </div>
        </Collapse>


        <Collapse
          name={"Rigging"}
        >
          <div className="row section capsule">
            <div className="column column-25"> </div>
            <div className="column column-offset-10">
              <h3> <Trans i18nKey="description.riggingMoto" /></h3>
              <p>
                <Trans i18nKey="description.rigging1" />
              </p>
              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://www.youtube.com/watch?v=t9lcvW_yZYQ" target="blank">How To Rig Motorcycle in Blender 2.9 - Blender 3D</a>
                </em></p>
              </blockquote>

              <h3><Trans i18nKey="description.riggingCharacter" /></h3>
              <p>
                <Trans
                  i18nKey="description.rigging2"
                  components={{ italics: <span className="italics" />, }} />
              </p>

              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://www.youtube.com/watch?v=f2pTkW-1JkE" target="blank">Character Rigging - Blender 2.80 Fundamentals
                  </a>
                  <br /><a href="https://www.youtube.com/watch?v=4fICQmBEt4Y" target="blank">Blender 2.82: Weight Painting In 5 Minutes </a>
                </em></p>
              </blockquote>
              <div className="row images">
                <Zoom>
                  <img src={rigJoker} alt="shape key lacci"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did20" />
                </p>
              </div>
              <p>
                <Trans
                  i18nKey="description.rigging3"
                  components={{ italics: <span className="italics" />, }} />
              </p>

              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://www.youtube.com/watch?v=0bFrZn8xlLw" target="blank">Blender 2.82 : Inverse Kinematics In 60 Seconds! (Arm Rig) </a>
                  <br /><a href="https://www.youtube.com/watch?v=Pt3-mHBCoQk" target="blank">Blender 2.8 Inverse Kinematics In 2 Minutes!</a>
                </em></p>
              </blockquote>

              <div className="row images">
                <Zoom>
                  <img src={inverseK} alt="cinematica inversa"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did21" />
                </p>
              </div>

              <h3><Trans i18nKey="description.riggingFace" /></h3>
              <p>
                <Trans
                  i18nKey="description.rigging4"
                  components={{ italics: <span className="italics" />, }} />
              </p>
              <div className="row images">
                <Zoom>
                  <img src={schema_lacci} alt="shape key lacci"></img>
                </Zoom>
                <Zoom>
                  <img src={lacci} alt="shape key lacci"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans
                    i18nKey="description.did22"
                    components={{ italics: <span className="italics" />, }} />
                </p>
              </div>
            </div>
          </div>
        </Collapse>


        <Collapse
          name={<Trans i18nKey="description.animationTitle" />}
        >
          <div className="row section capsule">
            <div className="column column-25"></div>

            <div className="column column-offset-10">
              <p><Trans i18nKey="description.animation1" /></p>
              <h3><Trans i18nKey="description.animationCamera" /></h3>
              <p>
                <Trans
                  i18nKey="description.animation3"
                  components={{ bold: <span className="bold" />, }} />
                <br />
                <Trans
                  i18nKey="description.animation4"
                  components={{ bold: <span className="bold" />, }} />
                <br />
                <Trans
                  i18nKey="description.animation5"
                  components={{ bold: <span className="bold" />, }} />
                <br />
                <Trans
                  i18nKey="description.animation6"
                  components={{ italics: <span className="italics" />, bold: <span className="bold" /> }} />
              </p>

              <h3><Trans i18nKey="description.animationProcess" /></h3>
              <p>
                <Trans
                  i18nKey="description.animation7"
                  components={{ bold: <span className="bold" />, }} />
                <br />
                <Trans
                  i18nKey="description.animation8"
                  components={{ bold: <span className="bold" />, }} />
                <br />
                <Trans
                  i18nKey="description.animation9"
                  components={{ bold: <span className="bold" />, }} />
                <br />
                <Trans
                  i18nKey="description.animation10"
                  components={{ italics: <span className="italics" />, bold: <span className="bold" /> }} />
              </p>

              <h3><Trans i18nKey="description.animationHair" /></h3>
              <p>
                <Trans
                  i18nKey="description.animation11"
                  components={{ bold: <span className="bold" />, italics: <span className="italics" /> }} />
                <br />
                <Trans
                  i18nKey="description.animation12"
                  components={{ bold: <span className="bold" />, italics: <span className="italics" /> }} />
              </p>
              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://www.youtube.com/watch?v=gTdRGZA4TXA" target="blank">Blender 2.82 : Hair Rigging, Physics, & Animation</a>
                </em></p>
              </blockquote>

              <h3><Trans i18nKey="description.animationClothes" /></h3>
              <p>
                <Trans
                  i18nKey="description.animation13"
                  components={{ bold: <span className="bold" />, italics: <span className="italics" /> }} />
              </p>
              <p>
                <Trans
                  i18nKey="description.animation14"
                  components={{ bold: <span className="bold" />, }} />
              </p>
              <blockquote>
                <p><em><span className="bold">Tutorial:</span>
                  <br /><a href="https://www.youtube.com/watch?v=m61PlfM0hjE" target="blank">Satisfying wave displacement(tutorial) blender 2.92  </a>
                </em></p>
              </blockquote>


              <Slideshow img={cloth} />

              <div className="caption">
                <p>
                  <Trans i18nKey="description.did23" />
                </p>
              </div>
              <h3><Trans i18nKey="description.animationComplex" /></h3>
              <p>
                <Trans
                  i18nKey="description.animation15"
                  components={{ italics: <span className="italics" />, }} />
              </p>
              <p>
                <Trans
                  i18nKey="description.animation16"
                  components={{ italics: <span className="italics" />, }} />
              </p>
            </div>

          </div><div className="row">
            <div className="column column-25"></div>
            <div className="column caption column-offset-10">
              <ReactPlayer
                url={caduta}
                playing={true}
                controls={false}
                muted={true}
                playsinline={true}
                onReady={onLoadedData}
                loop={true}
                width={"100%"}
                height={"auto"}
              />
              <p>
                <Trans i18nKey="description.did24" />
              </p>
              <div className="row images">
                <Zoom>
                  <img src={timeline} alt="timeline scena 14"></img>
                </Zoom>
              </div>
              <div className="caption">
                <p>
                  <Trans i18nKey="description.did25" />
                </p>
              </div>
            </div>
          </div>
        </Collapse>

      </div >
      <div className="column"></div>
    </div >

  )
}